export const PERMIT_EXTENSION_STATUS = {
    pendente_guias_e_datas: "Pendente dados guias e datas (MFCE-M)",
    report_m: "Pendente parecer técnico (MFCE-M)",
    payment_e: "Pendente valor de pagamento (MFCE-E)",
    invoice_s: "Pendente factura (S)",
    signature_s: "Pendente firma Direcção (S)",
    approved: "Aprovada",
    not_approved: "Não aprovada",
};

export const isOpenExtension = status => {
    return (
        status !== PERMIT_EXTENSION_STATUS.approved &&
        status !== PERMIT_EXTENSION_STATUS.not_approved
    );
};
